import { loadableWithFallback } from '@vision/ui/utils';
import type { TableChartAtaProps } from './TableChartAta';

export const TableChartAta = loadableWithFallback<TableChartAtaProps>(() => import('./TableChartAta'));
